var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadphonesMicro = function SvgHeadphonesMicro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#322500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 15v-3m0 0a9 9 0 1 1 18 0M3 12v4a2 2 0 0 0 .59 1.41A2 2 0 0 0 5 18h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm18 0v3m0-3v4m0-4h-3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1a2 2 0 0 0 1.41-.59A2 2 0 0 0 21 16m0 0v3a3 3 0 0 1-3 3h-6"
  })));
};
export default SvgHeadphonesMicro;